// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VoicePayload__container-a128a6 {
  width: 100vw;
  max-width: 100%;
  display: flex;
  flex: 1;
}

.VoicePayload__file-container-d1d0ac {
  display: flex;
}

.VoicePayload__preview-content-b2c313 {
  flex: 1;
  margin-inline-start: 8px;
}

.VoicePayload__time-abff6e {
  color: var(--chat-bubble-text-secondary);
  min-width: 100px;
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle);
}

.VoicePayload__wave-ae4518 {
  height: 24px;
}

.VoicePayload__audio-fa07a8 {
  display: none;
}

.VoicePayload__button-afd5db {
  flex: 0 0 auto;
  margin-inline-start: 10px;
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  box-sizing: border-box;
  width: 24px;
  height: 24px;
  border-radius: 6px;
  color: var(--chat-bubble-primary);
  background-color: var(--chat-bubble-primary-soft);
}

.VoicePayload__button-afd5db svg {
  fill: currentColor;
}

.VoicePayload__loader-c3eae5 {
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 1;
  margin-inline-start: -8px;
  margin-top: -8px;
}

.VoicePayload__text-container-c5c3cc {
  color: var(--chat-bubble-text-primary);
  font: var(--font-body-5);
  letter-spacing: var(--font-spacing-body-5);
  margin-top: 12px;
}

.VoicePayload__text-container-c5c3cc:after {
  content: "";
  width: 90px;
  display: inline-block;
}

.VoicePayload__error-d80149 {
  color: var(--chat-bubble-text-secondary);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/Payload/VoicePayload/VoicePayload.styles.m.css"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,eAAA;EACA,aAAA;EACA,OAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,OAAA;EACA,wBAAA;AACF;;AAEA;EACE,wCAAA;EACA,gBAAA;EACA,4BAAA;EACA,4CAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iCAAA;EACA,iDAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,yBAAA;EACA,gBAAA;AACF;;AAEA;EACE,sCAAA;EACA,wBAAA;EACA,0CAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,WAAA;EACA,qBAAA;AACF;;AAEA;EACE,wCAAA;AACF","sourcesContent":[".container {\n  width: 100vw;\n  max-width: 100%;\n  display: flex;\n  flex: 1;\n}\n\n.file-container {\n  display: flex;\n}\n\n.preview-content {\n  flex: 1;\n  margin-inline-start: 8px;\n}\n\n.time {\n  color: var(--chat-bubble-text-secondary);\n  min-width: 100px;\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle);\n}\n\n.wave {\n  height: 24px;\n}\n\n.audio {\n  display: none;\n}\n\n.button {\n  flex: 0 0 auto;\n  margin-inline-start: 10px;\n  position: relative;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  box-sizing: border-box;\n  width: 24px;\n  height: 24px;\n  border-radius: 6px;\n  color: var(--chat-bubble-primary);\n  background-color: var(--chat-bubble-primary-soft);\n}\n\n.button svg {\n  fill: currentColor;\n}\n\n.loader {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  z-index: 1;\n  margin-inline-start: -8px;\n  margin-top: -8px;\n}\n\n.text-container {\n  color: var(--chat-bubble-text-primary);\n  font: var(--font-body-5);\n  letter-spacing: var(--font-spacing-body-5);\n  margin-top: 12px;\n}\n\n.text-container:after {\n  content: '';\n  width: 90px;\n  display: inline-block;\n}\n\n.error {\n  color: var(--chat-bubble-text-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `VoicePayload__container-a128a6`,
	"file-container": `VoicePayload__file-container-d1d0ac`,
	"fileContainer": `VoicePayload__file-container-d1d0ac`,
	"preview-content": `VoicePayload__preview-content-b2c313`,
	"previewContent": `VoicePayload__preview-content-b2c313`,
	"time": `VoicePayload__time-abff6e`,
	"wave": `VoicePayload__wave-ae4518`,
	"audio": `VoicePayload__audio-fa07a8`,
	"button": `VoicePayload__button-afd5db`,
	"loader": `VoicePayload__loader-c3eae5`,
	"text-container": `VoicePayload__text-container-c5c3cc`,
	"textContainer": `VoicePayload__text-container-c5c3cc`,
	"error": `VoicePayload__error-d80149`
};
module.exports = ___CSS_LOADER_EXPORT___;
